import {
  Box,
  Flex,
  Text,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
} from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";

export function NovaIsencaoField({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <Box
      bg="blue.50"
      border="1px solid"
      borderColor="blue.200"
      borderRadius="lg"
      p="16px"
    >
      <Flex align="center" gap="8px" mb="12px">
        <Text fontSize="sm" fontWeight="semibold" color="gray.800">
          Cenário fiscal para cálculo de margem
        </Text>
        <Tooltip
          label="Define como o IR afeta o benefício líquido e, por consequência, a margem consignável."
          fontSize="xs"
          bg="gray.800"
          color="white"
          borderRadius="md"
          p="8px"
          maxW="256px"
          placement="top"
        >
          <InfoIcon w="16px" h="16px" color="blue.600" cursor="help" />
        </Tooltip>
      </Flex>

      <RadioGroup
        value={`${value}`}
        onChange={(value) => {
          onChange(value === "true");
        }}
      >
        <Stack spacing="12px">
          {/* Option 1 */}
          <Box
            as="label"
            cursor="pointer"
            p="12px"
            bg="white"
            borderRadius="md"
            // _hover={{ bg: "blue.50" }}
            transition="background-color 0.2s"
          >
            <Flex align="start" gap="12px">
              <Radio value="true" mt="4px" colorScheme="blue" />
              <Box>
                <Text fontSize="sm" fontWeight="medium" color="gray.800">
                  IR — Nova regra (isenção até R$ 5.000)
                </Text>
                <Text fontSize="xs" color="gray.600" mt="4px">
                  Ao selecionar esta opção, o cálculo considera a nova regra do
                  Imposto de Renda, que isenta ou reduz o IR para quem se
                  enquadrar, resultando em uma maior margem disponível para o
                  cliente.
                </Text>
              </Box>
            </Flex>
          </Box>

          {/* Option 2 */}
          <Box
            as="label"
            cursor="pointer"
            p="12px"
            bg="white"
            borderRadius="md"
            // _hover={{ bg: "blue.50" }}
            transition="background-color 0.2s"
          >
            <Flex align="start" gap="12px">
              <Radio value="false" mt="4px" colorScheme="blue" />
              <Box>
                <Text fontSize="sm" fontWeight="medium" color="gray.800">
                  IR — Regra anterior
                </Text>
                <Text fontSize="xs" color="gray.600" mt="4px">
                  Aplica o cálculo do IRPF pela tabela progressiva mensal, sem
                  considerar a nova isenção até R$ 5.000 nem os descontos
                  associados, resultando em maior desconto de imposto e margem
                  menor.
                </Text>
              </Box>
            </Flex>
          </Box>
        </Stack>
      </RadioGroup>
    </Box>
  );
}
